import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M. S/C;</li>
                            <li>Axial P.M. C/C;</li>
                            <li>Axial Osso;</li>
                            <li>Sagital P.M. Orbita Direita S/C;</li>
                            <li>Sagital P.M. Orbita Esquerda S/C;</li>
                            <li>Sagital P.M. Orbita Direita C/C;</li>
                            <li>Sagital P.M. Orbita Esquerda C/C;</li>
                            <li>Sagital Osso Orbita Direita;</li>
                            <li>Sagital Osso Orbita Esquerda;</li>
                            <li>Coronal P.M. S/C;</li>
                            <li>Coronal P.M. C/C;</li>
                            <li>Coronal Osso;</li>
                            <li>3D VR Orbitas Dir. / Esq.;</li>
                            <li>3D VR Orbitas Sup. / Inf.;</li>
                            <li>3D MIP Orbitas Dir. / Esq.;</li>
                            <li>3D MIP Orbitas Sup. / Inf.;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}